import { buildUrl, Path } from "../../paths/Paths";
import { RouteConfiguration } from "../../types/routes/RouteConfiguration";
import { TypedInternalLinkBase } from "./TypedInternalLink";

export const getLoginPath = (returnLink: TypedInternalLinkBase<Path> = { to: "/dashboard", params: {} }) =>
  `${RouteConfiguration.Login}?return_Url=${buildUrl(returnLink.to, returnLink.params)}`;
